import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { InputControlBase } from './../forms/input-control.base';

@Component({
    selector: 'app-text-area-limited',
    templateUrl: './text-area-limited.component.html',
    styleUrls: ['./text-area-limited.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextAreaLimitedComponent extends InputControlBase {
  constructor() {
    super();
  }

  @Input() placeholder: string;
  @Input() limit: number = 300;
  @Input() rows: number = 4;
  @Input() hasBorder: boolean = false;
  // isTouched: boolean = false;

  get messageLength(): number {
    return (this.control?.value ?? '').length;
  }

  get isReadonly(): boolean {
    return this.control?.disabled || this.control?.isReadonly;
  }

  // onblur(): void {
  //   super.onblur();
  //   this.isTouched = true;
  //   if (this.control && !this.control.touched) {
  //     this.control.markAsTouched();
  //   }
  // }

  onblur(): void {
    super.onblur();
    this.control.markAsTouched();
    this.control.markAsDirty();
    this.control.updateValueAndValidity();
  }
}
